import { useRxCollectionPatient } from "$global-providers/rxdb-provider/collections/patient";
import { useEffect, useState } from "react";

/**
 * Reads a patient's `dob` (ISO date string) from the rxdb patient
 * collection. Used by the V2 exempt flow to validate age-restricted
 * exemption types (UNDER_5 / OVER_70).
 *
 * Returns `undefined` while loading or if the patient is not yet in the
 * local store — `applyPayment` will reject UNDER_5 / OVER_70 with a
 * clear "Patient DOB is required" error if invoked without it.
 */
export function useFetchPatientDobRxdb(
  patientId: string | undefined,
): string | undefined {
  const collection = useRxCollectionPatient();
  const [dob, setDob] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!collection || !patientId) {
      setDob(undefined);
      return;
    }
    const sub = collection.findOne(patientId).$.subscribe((doc) => {
      setDob(doc?.dob ?? undefined);
    });
    return () => sub.unsubscribe();
  }, [collection, patientId]);

  return dob;
}
